import React from 'react';
import useContext from '../../../../hooks/useContext';
import store from '../../../../store';
import usePropsSelector from '../../../../store/propsStore/usePropsSelector';
import { ApiaComponentContextPrimitive } from '../apiaComponent/ApiaComponentContext';
import { DataGridIdentifier } from './apiaDataGrid/context';

export default function useApiaFieldCommonProps(modifiers?: {
  className?: string;
}) {
  const {
    fieldId,
    field: { fieldType, attName, valueType, attId },
  } = useContext(ApiaComponentContextPrimitive);
  const { name, attributes, ...props } = usePropsSelector(fieldId);
  const gridIdentifier = React.useContext(DataGridIdentifier);
  const isGridReadonly = React.useMemo(() => {
    if (gridIdentifier?.gridId) {
      return store.getState().dataGridSlice[gridIdentifier.gridId].context.grid
        .field.properties.readonly;
    }
    return false;
  }, [gridIdentifier?.gridId]);

  const isReadonly =
    [
      String(props.readonly),
      String(props.readOnly),
      String(isGridReadonly),
    ].findIndex(
      (current) =>
        current.toLowerCase() === 'true' || current.toLowerCase() === 't',
    ) !== -1;

  const identifier = React.useMemo(
    () => ({
      id: fieldId,
      'data-name': name || attName,
      'data-type': fieldType,
      'data-att-id': attId,
      'data-field-in-grid': attributes?.onGrid,
      'data-idx': attributes?.index,
      'data-value-type': valueType,
      'data-field-id': fieldId,
      className: `${isReadonly ? 'readOnly' : ''} ${
        modifiers?.className ?? ''
      } ${attName ?? ''}`,
    }),
    [
      fieldId,
      name,
      attName,
      fieldType,
      attId,
      attributes?.onGrid,
      attributes?.index,
      valueType,
      isReadonly,
      modifiers?.className,
    ],
  );

  return { isReadonly, identifier };
}
